export default function($, list, selected_filter, loaded_posts, posts_per_load) {
  if (!posts_per_load) {
    posts_per_load = 10;
  }

  if (selected_filter === 'all') {
    $('ul[data-list="' + list + '"]').children('li').hide();

    if (loaded_posts < 0) {
      $('ul[data-list="' + list + '"]').children('li').css('display', 'flex').hide().fadeIn('slow');
    } else {
      $('ul[data-list="' + list + '"]').children('li:lt(' + loaded_posts + ')').css('display', 'flex');
      $('ul[data-list="' + list + '"]').children('li:lt(' + loaded_posts + '):gt(' + (loaded_posts - posts_per_load - 1) + ')').hide().fadeIn('slow');

      if ($('ul[data-list="' + list + '"]').children('li').length > loaded_posts) {
        $('.load-more-posts[data-list="' + list + '"]').show();
      } else {
        $('.load-more-posts[data-list="' + list + '"]').hide();
      }
    }

  } else {
    // Support multiple terms so we can't just do this properly with a css query
    var items_shown = 0;
    var has_more = false;
    $('ul[data-list="' + list + '"]').children('li').each(function(index, item) {
      var terms = $(item).attr('data-filter-terms');

      terms = terms.split(',');

      // Just to support IE 11...
      var found = false;

      for (var i in terms) {
        if (terms[i] === selected_filter) {
          found = true;
          break;
        }
      }

      if (found === true) {
        if ((items_shown < loaded_posts || loaded_posts < 0)) {
          $(item).css('display', 'flex').hide().fadeIn('slow');
          items_shown++;
        } else {
          has_more = true;
        }
      } else {
        $(item).hide();
      }
    });

    if (has_more === true) {
      $('.load-more-posts[data-list="' + list + '"]').show();
    } else {
      $('.load-more-posts[data-list="' + list + '"]').hide();
    }
  }
}
